import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    maxWidth: [null, '345px'],
    margin: ['0px auto 20px', '0px 20px'],
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  imageContainer: {
    width: ['44px', '125px'],
    height: ['44px', '125px'],
    margin: ['0px auto 8px', '0px auto 32px'],
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  title: {
    marginBottom: ['8px', '28px'],
  },
  paragraph: {
    marginBottom: ['10px', '31px'],
    maxWidth: ['205px', 'initial'],
  },
  numbers: {
    marginBottom: ['0px', '31px'],
    color: 'lavender.100',
  },
  subtext: {
    maxWidth: ['205px', 'initial'],
  },
};
